var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClasses,attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"app-button__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }